import { render, staticRenderFns } from "./MyUnitsFaults.vue?vue&type=template&id=7b64f158&scoped=true&"
import script from "./MyUnitsFaults.vue?vue&type=script&lang=js&"
export * from "./MyUnitsFaults.vue?vue&type=script&lang=js&"
import style0 from "./MyUnitsFaults.vue?vue&type=style&index=0&id=7b64f158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64f158",
  null
  
)

export default component.exports